import _ from 'lodash'
import $ from 'jquery'
export var {DateTime, Duration} = require('luxon')

import storage from './storage'

var movieStore = 'MovieBooking'

var timerStore = 'REUtils'
var timerPath = timerStore + '.Timer'

var updater = null
var state = {
  duration: null,
  durationSeconds: null,
  startTime: null,
  startValue: null,
  endTime: null,
  endValue: null,
  running: false,
  elapsed: null,
  remaining: null,
  updater: null,
  timeout: null,
}

function interval(func, wait, options) {
  let cancelled = false
  var callback = function (w, options) {
    return function () {
      if (!cancelled) {
        setTimeout(callback, w)
        try {
          func.call(null)
        } catch (e) {
          cancelled = true
          throw e.toString()
        }
      }
    }
  }(wait, options)

  var ret = {
    start() {
      callback()
      return ret
    },
    stop() {
      cancelled = true
      return ret
    },
    cancel() {
      cancelled = true
      return ret
    }
  }
  return ret
}

var helpers = {
  startTimer(duration = null, options) {
    state = getTimer()

    var now = DateTime.local()
    now.setZone('UTC')
    // if duration is a number it is expected to be in seconds and hence setting it to milliseconds as per DateTime.plus format
    if (duration instanceof Duration) {
      setTimerProperty({durationSeconds: duration.valueOf() / 1000})
    } else if (duration instanceof Object) {
      setTimerProperty({durationSeconds: Duration.fromObject(duration).valueOf() / 1000})
    } else if (_.isNil(duration)) {
      duration = state.duration
    } else {
      setTimerProperty({durationSeconds: duration})
      duration *= 1000
    }
    var end = now.plus(duration)

    var newState = {}
    newState.startTime = now
    newState.startValue = now.valueOf()
    newState.endTime = end
    newState.endValue = end.valueOf()
    newState.duration = duration
    newState.running = true
    newState.timeout = false

    setTimerProperty(newState)

    this.resumeTimer(options)

    return setTimerProperty({updater})
  },
  stopTimer() {
    if (updater && updater.cancel) {
      updater.cancel()
      updater = null
    }
    var newState = {}
    newState.running = false
    newState.startTime = null
    newState.startValue = null
    newState.endTime = null
    newState.endValue = null
    newState.durationSeconds = null
    newState.duration = null
    newState.updater = null

    return setTimerProperty(newState)
  },
  resumeTimer(options) {
    updater = interval(() => {
      var state = helpers.calculate()
      if (options.tick) {
        options.tick(state)
      }
      if (!state.running) {
        this.stopTimer()
      }
    }, 1000).start()
  },
  calculate() {
    var state = getTimer()
    // console.log(store, store.commit)
    if (state.running) {
      var nowDate = DateTime.local()
      nowDate.setZone('UTC')
      var now = nowDate.valueOf()

      var remaining = Math.max(0, (state.endValue - now) / 1000)
      var props = {remaining}

      if (remaining <= 0) {
        props.timeout = true
        this.stopTimer()
      } else {
        props.elapsed = ((now - state.startValue) / 1000)
      }
      state = setTimerProperty(props)
    }
    return state
  }
}

export function getTimer() {
  return state = storage.getPath(timerStore, timerPath)
}

export function setTimerProperty(props) {
  _.forOwn(props || {}, (value, key) => {
    storage.setPath(timerStore, timerPath + '.' + key, value)
    state[key] = value
  })
  return state
}

export function isTimerRunning() {
  return !!(getTimer().running)
}

function parseOptions(options) {
  return _.isFunction(options) ? {tick: options} : (options || {})
}
export function refreshTimer(options) {
  options = parseOptions(options)
  var state = helpers.calculate()
  if (state.timeout) {
    helpers.stopTimer()
    state = setTimerProperty({timeout: null})
    if (options.tick) {
      options.tick(state)
    }
  } else  if (state.running) {
    state = resumeTimer(options)
  }
  return state
}

export function resumeTimer(options) {
  return helpers.resumeTimer(parseOptions(options))
}

export function startTimer(duration, options) {
  return helpers.startTimer(duration, parseOptions(options))
}

state = getTimer()

export function parseDateTime(date) {

  if (!date) {
    return date
  }

  if (!(date instanceof DateTime)) {
    if (/\s/.test(date)) {
      return DateTime.fromSQL(date)
    }
    else if (/\-/.test(date)) {
      return DateTime.fromISO(date)
    }
    else if (!/\D/.test(date)) {
      return DateTime.fromMillis(1 * date)
    }
    else if (/\//.test(date)) {
      return DateTime.fromJSDate(new Date(date))
    }
    else if (_.isString(date)) {
      return DateTime.fromJSDate(new Date(date))
    }
    else if (date instanceof Date) {
      return DateTime.fromJSDate(date)
    }
    else if (_.isObject(date)) {
      return DateTime.fromObject(date)
    }
  }
  return date
}

export function formatDate(date, format, prefix = '', suffix = '') {
  const datetime = parseDateTime(date).setLocale('en-US')
  if (datetime.isValid) {
    format = format || 'DDD'
    return prefix + datetime.toFormat(format) + suffix
  }

  return ''
}

export function timeFormatted(time) {
  return formatDate(DateTime.fromSeconds(time, {zone: 'UTC'}), 'H:mm:ss')
}

var cartTimer = {getTimer, isTimerRunning, refreshTimer, resumeTimer, startTimer, timeFormatted}
export default cartTimer
